import * as React from 'react';
export const tasksSvg = React.forwardRef(function tasksSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 13.8a.8.8 0 0 1 .8-.8h12.4a.8.8 0 0 1 0 1.6H1.8a.8.8 0 0 1-.8-.8Zm7-8a.8.8 0 0 1 .8-.8h5.4a.8.8 0 0 1 0 1.6H8.8a.8.8 0 0 1-.8-.8Zm-7 4a.8.8 0 0 1 .8-.8h12.4a.8.8 0 0 1 0 1.6H1.8a.8.8 0 0 1-.8-.8ZM8.71.211a.85.85 0 0 1 .079 1.2l-4.65 5.3a.85.85 0 0 1-1.196.081l-2.65-2.3a.848.848 0 0 1-.085-1.2.85.85 0 0 1 1.2-.084l2.01 1.746L7.512.289a.848.848 0 0 1 1.2-.078Z',
    }),
  );
});
tasksSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tasks = {
  category: 'icon',
  colorable: true,
  name: 'tasks',
  svg: tasksSvg,
};
